import React, { useState, useEffect, useRef, useCallback } from 'react';
import { EditText } from 'react-edit-text';
import 'react-edit-text/dist/index.css';
import AddPlatforms from './AddStreamingPlatforms';
import imgThumbnail from "../../../../img/thumbnail.png";
import { handleSongList } from '../../../../_services/creater/creatorSongList.service';
import { useDispatch, useSelector } from 'react-redux';
import { setSnackBar, setSnackBarMessage, setSnackBarVariant } from '../../../../redux';
import { formSnackbar } from '../../../../_services/_constants/snackbar.constant';
import useMediaQuery from '@mui/material/useMediaQuery';
import DeleteModal from '../../../../components/reusableComponents/DeleteModal';
import AddIcon from '@mui/icons-material/Add';
import CreatePlaylistModal from '../playlist/CreatePlaylistModal';
import { Drawer, ListItemIcon, Menu, MenuItem, MenuList, Paper, Skeleton, Typography } from '@mui/material';
import platform from '../../../../img/Platform.svg';
import playlist from '../../../../img/Playlist.svg';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { updatePlateformSequence } from '../../../../_services/platform/platformSequence';
import AddMusicDetailsModal from './AddMusicDetailsModal';
import CloseIcon from '@mui/icons-material/Close';
import FirebaseImageStore from '../../../../_helpers/reusablefunctions/firebaseImageStore';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { handleRelatedPlatform } from '../../../../_services/creater/relatedPlatfom.service';
import { SkeletonWaveCard } from '../../../../_helpers/reusablefunctions/SkeletonCard';

export const StreamingPlatformContext = React.createContext();

const AddSong = ({
  deleteSongHandler, index, id, data = {},
  songTagsList = [], allPlatfromList = [], reRenderPlatformHandler,
  allPlatfromListCopy = [], setAllPlatformList, setRelatedPlatform, relatedPlatform = [],
  provided, disableHandler, setPlaylistLoading, songsListData = [], getRelatedPlatforms,
  genre = [], moodList = [], languageList = [], loading, playlistItems,
  getPlaylistList, setPlaylistItems, playlistLoading, renderSongList
}) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userData.userData);
  const smallViewport = useMediaQuery('(max-width:768px)');
  const [songTitle, setSongTitle] = useState(data.songTitle ?? '');
  const [songSlug, setSongSlug] = useState(data.slug ?? '');
  const [visiblityStatus, setVisibilityStatus] = useState(!!(data.visible && data.songTitle));
  const [songPoster, setSongPoster] = useState(
    data.songPoster_url
      ? data.songPoster_url
      : data?.cover_image
        ? `${process.env.REACT_APP_SONGAPIURL_MEDIA}${data?.cover_image}`
        : null
  );
  const [selectedFile, setSelectedFile] = useState();
  const [artist, setArtistList] = useState(data.artists ? data.artists.split(',') : []);
  const [selectedTags, setSelectedTags] = useState(data.tags ? data.tags.split(',') : []);
  const [disableAddNewPlatform, setDisableAddNewPlatform] = useState(false);
  const [loaderClass, setLoaderClass] = useState('');
  const [errorSongTitle, setErrorSongTitle] = useState();
  const [disableViewSatus, setDisableViewStatus] = useState(!(data.id && songTitle));
  const [errorTags, setErrorTags] = useState();
  const [tagHelperText, setTagHelperText] = useState(null);
  const bodyRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openPlaylist, setOpenPlaylist] = useState(false);
  const [openMusicModal, setOpenMusicModal] = useState(false);
  const { saveAvatar } = FirebaseImageStore({ selectedFile, functionCall: saveProfileAvatar });
  const openMenu = Boolean(anchorEl);

  const [posterInfo, setPosterInfo] = useState({ file: [], filepreview: null });
  const [invalidImage, setInvalidImage] = useState(null);
  const ref = useRef();
  const [open, setOpen] = useState(false);

  const isDisabled = data.is_admin_created;

  // Handlers
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleOpenPlaylist = () => setOpenPlaylist((prev) => !prev);

  const handleDrawerOpen = (id) => {
    getRelatedPlatforms(id);
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setRelatedPlatform([])
    setOpen(false);
  }

  useEffect(() => {
    if (data.songPoster_url) {
      setSongPoster(data.songPoster_url);
    } else if (data?.cover_image) {
      setSongPoster(`${process.env.REACT_APP_SONGAPIURL_MEDIA}${data?.cover_image}`);
    } else {
      setSongPoster(null);
    }
  }, [data.songPoster_url, data?.cover_image]);

  useEffect(() => {
    if (selectedFile) saveAvatar();
  }, [selectedFile]);

  // Validation and change handlers
  const songTitleValidationHandler = (string) => {
    const regex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/;
    if (string) {
      if (regex.test(string)) return false;
      setVisibilityStatus(true);
      setErrorSongTitle(null);
      setDisableViewStatus(false);
      return true;
    }
    setVisibilityStatus(false);
    setErrorSongTitle('Please enter a valid song title');
    setDisableViewStatus(true);
    return false;
  };

  const songSlugChangeHandler = ({ value }) => {
    setSongSlug(value);
    userData.id && id == undefined ? createSong({ songSlug: value }) : updateSong({ songSlug: value });
  };

  const songTitleChangeHandler = ({ value }) => {
    setSongTitle(value);
    const valid = songTitleValidationHandler(value);
    if (valid) {
      setErrorSongTitle(null);
      userData.id && id == undefined ? createSong({ songTitle: value }) : updateSong({ songTitle: value });
    } else if (value === '') {
      setErrorSongTitle(null);
      userData.id && id == undefined ? createSong({ songTitle: value }) : updateSong({ songTitle: value });
    } else {
      setErrorSongTitle('Please enter a valid song title');
    }
  };

  const tagsValidationHandler = (tags) => {
    const tagName = tags[tags.length - 1];
    const regex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/;
    if (tagName && tags.length > 0) {
      return !regex.test(tagName);
    }
    return true;
  };

  const songTagsChangeHandler = (event, value) => {
    const isValid = tagsValidationHandler(value);
    if (isValid) {
      setErrorTags(false);
      setTagHelperText(null);
      let newTag = null;
      let matchedTags = value.length > 0 ? songTagsList.find(item => item.tagName === value[value.length - 1]) : undefined;
      if (!matchedTags) {
        newTag = value[value.length - 1];
      }
      setSelectedTags(value);
      if (userData.id && id == undefined) {
        createSong({ tags: value, newTag }, 'UPDATE_TAGS');
      } else {
        updateSong({ tags: value, newTag }, 'UPDATE_TAGS');
      }
    } else {
      setErrorTags(true);
      setTagHelperText('Please enter a valid tag name.');
    }
  };

  const songThumbnailChangeHandler = (event) => {
    const imageFile = event.target.files[0];
    if (!imageFile) {
      setInvalidImage('Please select an image.');
      return;
    }
    if (!imageFile.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG|gif)$/)) {
      setInvalidImage('Please select a valid image (JPG, JPEG, PNG).');
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new window.Image();
      img.onload = () => {
        if (img.width < 300 || img.height < 300) {
          setInvalidImage('Please select a 300x300 image.');
          return;
        }
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 600;
        canvas.height = 600;
        ctx.drawImage(img, 0, 0, 600, 600);
        canvas.toBlob((blob) => {
          const file = new File([blob], imageFile.name, {
            type: 'image/jpeg',
            lastModified: Date.now(),
          });
          setPosterInfo(prev => ({ ...prev, file, filepreview: URL.createObjectURL(file) }));
          setLoaderClass('uploadInProgress');
        }, 'image/jpeg', 1);
        setInvalidImage(null);
        setSelectedFile(imageFile);
      };
      img.onerror = () => setInvalidImage('Please select a valid image.');
      img.src = e.target.result;
    };
    reader.readAsDataURL(imageFile);
  };

  const combineChangeHanddler = (event) => {
    setVisibilityStatus(event.target.checked);
    userData.id && id == undefined
      ? createSong({ visible: event.target.checked })
      : updateSong({ visible: event.target.checked });
  };

  function saveProfileAvatar({ downloadURL }) {
    userData.id && id == undefined
      ? createSong({ songPosterThumbnail: downloadURL })
      : updateSong({ songPosterThumbnail: downloadURL });
  }

  // Create and update song
  const createSong = (postObj, type) => {
    dispatch(setSnackBar(true));
    dispatch(setSnackBarMessage(formSnackbar.songPlaylist.songCreate));
    dispatch(setSnackBarVariant('info'));
    const formData = new FormData();
    postObj.songPosterThumbnail && formData.append('songPoster_url', postObj.songPosterThumbnail);
    postObj.songTitle && formData.append('songTitle', postObj.songTitle);
    postObj.songSlug && formData.append('slug', postObj.songSlug);
    postObj?.musicDetailData?.genre && formData.append('genre', postObj.musicDetailData.genre);
    postObj?.musicDetailData?.mood && formData.append('mood', postObj.musicDetailData.mood);
    postObj?.musicDetailData?.language && formData.append('language', postObj.musicDetailData.language);
    postObj?.musicDetailData?.isrc && formData.append('isrc', postObj.musicDetailData.isrc);
    postObj?.musicDetailData?.artists && formData.append('artists', postObj.musicDetailData.artists);
    postObj.visible !== undefined && formData.append('visible', postObj.visible);
    formData.append('song_order', songsListData.length < 1 ? '0' : index);
    if (songsListData.length > 0) {
      const songD = songsListData.map((item, idx) => ({
        songId: item.id ? item.id : 'null',
        index: idx,
      }));
      formData.append('songsList', JSON.stringify(songD));
    }
    if (type === 'UPDATE_ARITSTS') formData.append('artists', postObj.artists.join(','));
    if (type === 'UPDATE_TAGS') formData.append('tags', postObj.tags);
    formData.append('userId', userData.id);
    handleSongList(formData, 'POST')
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(setSnackBarMessage(formSnackbar.songPlaylist.songCreateSuccess));
          dispatch(setSnackBarVariant('success'));
          setTimeout(() => dispatch(setSnackBar(false)), 2000);
          disableHandler();
          // renderSongList();
          bodyRef.current.focus();
        } else {
          dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
          dispatch(setSnackBarVariant('error'));
          setTimeout(() => dispatch(setSnackBar(false)), 2000);
        }
      })
      .catch(() => {
        dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
        dispatch(setSnackBarVariant('error'));
        setTimeout(() => dispatch(setSnackBar(false)), 2000);
      })
      .finally(() => {
        renderSongList();
      })
  };

  const updateSong = (postObj, type) => {
    dispatch(setSnackBar(true));
    dispatch(setSnackBarMessage(postObj?.songSlug ? formSnackbar.songPlaylist.songSlugUpdate : formSnackbar.songPlaylist.songLinkUpdate));
    dispatch(setSnackBarVariant('info'));
    const formData = new FormData();
    postObj.songPosterThumbnail && formData.append('songPoster_url', postObj.songPosterThumbnail);
    postObj.songTitle && formData.append('songTitle', postObj.songTitle);
    postObj.songSlug && formData.append('slug', postObj.songSlug);
    postObj?.musicDetailData?.genre && formData.append('genre', postObj.musicDetailData.genre);
    postObj?.musicDetailData?.mood && formData.append('mood', postObj.musicDetailData.mood);
    postObj?.musicDetailData?.language && formData.append('language', postObj.musicDetailData.language);
    postObj?.musicDetailData?.isrc && formData.append('isrc', postObj.musicDetailData.isrc);
    postObj?.musicDetailData?.artists && formData.append('artists', postObj.musicDetailData.artists);
    postObj.visible !== undefined && formData.append('visible', postObj.visible);
    if (type === 'UPDATE_ARITSTS') formData.append('artists', postObj.artists.join(','));
    if (type === 'UPDATE_TAGS') formData.append('tags', postObj.tags);
    formData.append('songId', id);
    formData.append('userId', userData.id);
    handleSongList(formData, 'UPDATE')
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(setSnackBarMessage(postObj?.songSlug ? formSnackbar.songPlaylist.songSlugUpdateSuccess : formSnackbar.songPlaylist.songLinkUpdateSuccess));
          dispatch(setSnackBarVariant('success'));
          setTimeout(() => dispatch(setSnackBar(false)), 3000);
          //
          disableHandler();
          setLoaderClass('');
          bodyRef.current.focus();
        } else {
          if (response.data?.slug?.length) {
            dispatch(setSnackBarMessage(response.data?.slug[0]));
          } else {
            dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
          }
          dispatch(setSnackBarVariant('error'));
          setTimeout(() => dispatch(setSnackBar(false)), 2000);
        }
      })
      .catch((error) => {
        dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
        dispatch(setSnackBarVariant('error'));
        setTimeout(() => dispatch(setSnackBar(false)), 2000);
      })
      .finally(() => {
        renderSongList();
      })
  };

  // Platform handlers
  const handleAllPlatformList = (data, action) => {
    let localDataBKP = [...allPlatfromList];
    if (action === 'remove') {
      setAllPlatformList(localDataBKP.filter(entry1 => !data.some(entry2 => entry1?.platformId === entry2.streamingPlatform)));
    } else if (action === 'add') {
      let platform = allPlatfromListCopy.find(item => item?.platformId === data.streamingPlatform);
      setAllPlatformList([...allPlatfromList, platform]);
    } else if (action === 'update') {
      localDataBKP = localDataBKP.filter(item => item?.platformId !== data?.latestValue?.platformId);
      let platform = allPlatfromListCopy.find(item => item?.platformId === data.previousValue?.platformId);
      localDataBKP = [...localDataBKP, platform];
      setAllPlatformList(localDataBKP);
    }
  };

  const handleAddNewPlatform = () => {
    setRelatedPlatform([{}, ...relatedPlatform]);
    setDisableAddNewPlatform(true);
  };

  const deletePlatformHandler = (e, songid, relatedPlatformLinkId, idx, relatedPlatformData) => {
    let copyOfArray = [...relatedPlatform];
    if (copyOfArray.length > 0) {
      setRelatedPlatform(copyOfArray.filter(item => item.id !== relatedPlatformLinkId));
      setDisableAddNewPlatform(false);
      if (relatedPlatformLinkId !== undefined) {
        dispatch(setSnackBar(true));
        dispatch(setSnackBarMessage(formSnackbar.relatedPlatform.relatedPlatformDelete));
        dispatch(setSnackBarVariant('info'));
        if (JSON.stringify(copyOfArray[0]) === '{}') setDisableAddNewPlatform(true);
        let dataObj = {
          userId: userData.id,
          relatedPlatformLinkId,
          songId: songid
        };
        handleRelatedPlatform(dataObj, 'DELETE')
          .then((response) => {
            if (response.status === 200 || response.status === 204) {
              setTimeout(() => dispatch(setSnackBar(false)), 2000);
              dispatch(setSnackBarMessage(formSnackbar.relatedPlatform.relatedPlatformDeleteSuccess));
              dispatch(setSnackBarVariant('success'));
              handleAllPlatformList(relatedPlatformData, 'add');
            } else {
              dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
              dispatch(setSnackBarVariant('error'));
              setTimeout(() => dispatch(setSnackBar(false)), 2000);
            }
          })
          .catch(() => {
            dispatch(setSnackBar(true));
            dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
            dispatch(setSnackBarVariant('error'));
            setTimeout(() => dispatch(setSnackBar(false)), 2000);
          });
      }
    }
  };

  const addNewDisabledHandler = () => setDisableAddNewPlatform(false);

  // Platform drag and drop
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(relatedPlatform);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setRelatedPlatform(items);
    const data = items.map(song => song.id);
    let dataObj = { platform_ids: data.join(',') };
    updatePlateformSequence(userData.id, dataObj)
      .then((response) => {
        if (response.status === 200 || response.status === 204 || response.status === 201) {
          renderSongList();
        } else {
          dispatch(setSnackBar(true));
          dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
          dispatch(setSnackBarVariant('error'));
          setTimeout(() => dispatch(setSnackBar(false)), 2000);
        }
      })
      .catch(() => {
        dispatch(setSnackBar(true));
        dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
        dispatch(setSnackBarVariant('error'));
        setTimeout(() => dispatch(setSnackBar(false)), 2000);
      });
  };

  // Render
  return (
    <>
      <div
        ref={id !== undefined ? provided.innerRef : null}
        {...(id !== undefined ? provided.draggableProps : null)}
        {...(id !== undefined ? provided.dragHandleProps : null)}
        className="col-md-12 my-3 col-sm-12 col-12 rounded-3 shadow-custom bg-white"
        id={`song_${id}`}
      >
        <div>
          <div className="link-box">
            <div className="drag-hanlder">
              <div className="my-auto text-secondary cursorGrab text-center">
                <DragIndicatorIcon />
              </div>
            </div>
            <div className="link-details">
              <span className='w-100 text-end d-block text-body-tertiary' style={{ fontSize: '10px' }}>{isDisabled && 'System generated'}</span>
              <div className="link-inputs">
                <div className="profile-wrapper flex-wrap">
                  <div className="profile-pic-wrapper">
                    <div className={`pic-holder ${loaderClass} ${isDisabled ? ' blurred-disabled' : ''}`}>
                      <img
                        id="pf-img"
                        src={songPoster ?? imgThumbnail}
                        className="pic rounded-circle  imageOpacity d-block"
                        onError={(e) => { e.target.src = imgThumbnail; }}
                        alt="img"
                      />
                      <input
                        className="uploadProfileInput position-absolute"
                        type="file"
                        name="profile_pic"
                        id={`songPoster_${id}`}
                        accept="image/*"
                        style={{ opacity: '0' }}
                        onChange={songThumbnailChangeHandler}
                        disabled={isDisabled}
                      />
                      <label htmlFor={`songPoster_${id}`} className="upload-file-block">
                        <div className="text-center" title="Please upload an image with the resolution of max 250*250px">
                          <div className="mb-2">
                            <i className="fa fa-camera fa-2x"></i>
                          </div>
                          <div className="text-uppercase">Update <br /></div>
                        </div>
                      </label>
                      {loaderClass && (
                        <div className="upload-loader">
                          <div className="spinner-border text-light" role="status">
                            <span className="sr-only"></span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {invalidImage && (
                    <div className="custom-tooltip">
                      <span className="tooltip-text">{invalidImage}</span>
                      <span className="top"></span>
                    </div>
                  )}
                </div>
                <div className="link-wrapper">

                  <div className="link-input-btns">
                    <div className="form-check form-switch d-flex align-items-center mediaMusic">
                      <button
                        disabled={id === undefined}
                        className='gn-btn-icononly me-2'
                        aria-controls={openMenu ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={openMenu ? 'true' : undefined}
                        onClick={handleClick}
                      >
                        <span className='text-secondary'><AddIcon /></span>
                      </button>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleClose}
                        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                        PaperProps={{ sx: { maxWidth: '500px' } }}
                      >
                        <Paper sx={{ width: 270, boxShadow: 'none' }}>
                          <MenuList>
                            <MenuItem onClick={() => { handleClose(); handleDrawerOpen(id); }}>
                              <ListItemIcon><img src={platform} alt='platform' /></ListItemIcon>
                              <Typography variant="inherit">Add Platform</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleOpenPlaylist}>
                              <ListItemIcon><img src={playlist} alt='playlist' /></ListItemIcon>
                              <Typography variant="inherit">Add Playlist</Typography>
                            </MenuItem>
                            <MenuItem onClick={() => setOpenMusicModal(true)}>
                              <ListItemIcon><img src={platform} alt='details' /></ListItemIcon>
                              <Typography variant="inherit">Add Song Details</Typography>
                            </MenuItem>
                          </MenuList>
                        </Paper>
                      </Menu>
                      <CreatePlaylistModal
                        setPlaylistLoading={setPlaylistLoading}
                        setPlaylistItems={setPlaylistItems}
                        playlistLoading={playlistLoading}
                        playlistItems={playlistItems}
                        getPlaylistList={getPlaylistList}
                        openPlaylist={openPlaylist} handleOpenPlaylist={handleOpenPlaylist} closeCreateModal={handleClose} songData={data} userId={userData && userData.id} songId={data.id} />
                      <label className="switch">
                        <input
                          disabled={disableViewSatus}
                          checked={visiblityStatus}
                          type="checkbox"
                          id={data.id}
                          role="switch"
                          onChange={combineChangeHanddler}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                  <div className="link-input-fields bg-white p-0">
                    <div className="w-50 me-1 bg-light rounded">
                      <EditText
                        name="song-title"
                        className={`${isDisabled ? 'blurred-disabled ' : ''} p-2 w-100`}
                        defaultValue={songTitle}
                        onSave={songTitleChangeHandler}
                        placeholder="Song title"
                        readonly={isDisabled}
                      />
                      {errorSongTitle && (
                        <div className="custom-tooltip">
                          <span className="tooltip-text">{errorSongTitle}</span>
                          <span className="top"></span>
                        </div>
                      )}
                    </div>
                    <div className="w-50 ms-1 bg-light rounded">
                      <EditText
                        name="song-title"
                        className={`${isDisabled ? 'blurred-disabled ' : ''} p-2 w-100`}
                        defaultValue={data?.slug}
                        onSave={songSlugChangeHandler}
                        placeholder="Song slug"
                        readonly={isDisabled}
                      />
                    </div>
                  </div>
                  <div className="link-input-fields bg-light">
                    <div className="w-100">
                      <Autocomplete
                        multiple
                        size="small"
                        id={`tags${id}`}
                        limitTags={1}
                        options={songTagsList.map((option) => option.tagName)}
                        value={selectedTags}
                        onChange={songTagsChangeHandler}
                        freeSolo
                        renderTags={(value, getTagProps) =>
                          value.map((option, idx) => (
                            <Chip
                              variant="filled"
                              size="small"
                              label={option}
                              deleteIcon={<CancelIcon style={{ color: '#333' }} />}
                              {...getTagProps({ index: idx })}
                              disabled={isDisabled}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            error={errorTags}
                            size="small"
                            sx={{ padding: '3px 0px' }}
                            placeholder="Tag"
                            className="removeBorder"
                            color="secondary"
                            disabled={isDisabled}
                          />
                        )}
                      />
                      {errorTags && (
                        <div className="custom-tooltip">
                          <span className="tooltip-text">{tagHelperText}</span>
                          <span className="top"></span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="action-btn-container">
                    <div className="inner-container" style={{ display: 'flex' }}>
                      <div className='link-action-btns'></div>
                      <div>
                        <button title="Delete"
                          className={`${isDisabled ? 'blurred-disabled ' : ''} gn-btn-icononly text-secondary`}
                          disabled={isDisabled}
                        >
                          {data && data.id !== undefined
                            ? <span id={data.id} onClick={() => ref.current.handleOpen()}><DeleteIcon /></span>
                            : <span id={data.id} onClick={() => deleteSongHandler(id, index)} className='text-secondary'><DeleteIcon /></span>
                          }
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DeleteModal cardId={data && data.id} deleteHandler={deleteSongHandler} ref={ref} />
        </div>
      </div>
      {/* Drawer for add platform */}
      <Drawer
        sx={{
          width: '500px',
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: smallViewport ? '100%' : '500px',
            boxSizing: 'border-box',
          },
        }}
        anchor="right"
        open={open}
      >
        <div>
          <div className="p-3 d-flex justify-content-between align-items-center" style={{ backgroundColor: '#0000000D' }}>
            <div><h5 className='m-0'>Add platform</h5></div>
            <div style={{ position: 'relative', top: '-5px' }}>
              <button title="Close" className="icononly-btn" onClick={handleDrawerClose}><CloseIcon /></button>
            </div>
          </div>
          <div className="px-4">
            <div className='text-end mt-3 mb-2'>
              <button
                className='gn-actionbtn'
                disabled={disableAddNewPlatform || allPlatfromList.length === 0 || isDisabled}
                onClick={handleAddNewPlatform}
              >ADD NEW</button>
            </div>
            {
              loading ? (
                <div>
                  {[1, 2, 3].map((i) => (
                    <SkeletonWaveCard key={i} />
                  ))}
                </div>
              ) : (
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="characters">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        <StreamingPlatformContext.Provider value={{ allPlatfromList, handleAllPlatformList, allPlatfromListCopy }}>
                          {open && relatedPlatform.map((platform, idx) => (
                            <Draggable key={platform.id ?? idx} draggableId={String(platform.id ?? idx)} index={idx}>
                              {(provided) => (
                                <AddPlatforms
                                  key={platform.id ?? idx}
                                  deletePlatformHandler={deletePlatformHandler}
                                  reRenderPlatformHandler={reRenderPlatformHandler}
                                  addNewDisabledHandler={addNewDisabledHandler}
                                  cardData={platform}
                                  songId={id}
                                  cardId={platform.id}
                                  index={idx}
                                  allRelatedPlatforms={relatedPlatform}
                                  provided={provided}
                                />
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </StreamingPlatformContext.Provider>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              )}
          </div>
        </div>
      </Drawer>
      <AddMusicDetailsModal
        data={data}
        compareId={id}
        handleCloseMenu={handleClose}
        createSong={createSong}
        updateSong={updateSong}
        setOpenMusicModal={setOpenMusicModal}
        openMusicModal={openMusicModal}
        genre={genre}
        moodList={moodList}
        languageList={languageList}
      />
      <div ref={bodyRef} tabIndex={-1} style={{ position: 'absolute', left: '-9999px' }}></div>
    </>
  );
};

export default AddSong;